import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-j03-a-result-screen" }
const _hoisted_2 = {
  key: 0,
  class: "p-j03-a-result-screen__header"
}
const _hoisted_3 = { class: "p-j03-a-result-screen__heading" }
const _hoisted_4 = { class: "p-j03-a-result-screen__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JMessageArticleList = _resolveComponent("JMessageArticleList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.heading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.heading) + _toDisplayString(_ctx.itemCountString), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_JMessageArticleList, {
        "message-article-list": _ctx.resultArray,
        exclude: _ctx.exclude
      }, null, 8, ["message-article-list", "exclude"])
    ])
  ]))
}